import { Routes } from '@angular/router';
import { authGuard } from 'app/authentitcation/guards/auth.guard';
import { loginGuard } from 'app/authentitcation/guards/login.guard';
import { isPwa } from 'app/pwa/pwa-utils';

export const routes: Routes = [
  {
    canActivate: [authGuard],
    loadComponent: () => {
      if (isPwa()) {
        return import('app/pwa/timer-widget/timer-widget.component').then((m) => m.TimerWidgetComponent);
      } else {
        return import('app/pages/home/home.component').then((file) => file.HomeComponent);
      }
    },
    title: 'title.timer',
    path: 'timer',
  },
  {
    canActivate: [loginGuard],
    loadComponent: () => {
      if (isPwa()) {
        return import('app/pwa/login-widget/login-widget.component').then((m) => m.LoginWidgetComponent);
      } else {
        return import('app/pages/login/login.component').then((file) => file.LoginComponent);
      }
    },
    title: 'title.login',
    path: 'login',
  },
  {
    loadComponent: () =>
      import('app/routing/not-found/not-found.component').then((file) => file.NotFoundComponent),
    title: '404',
    path: '404',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'timer',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '404',
  },
];
